import React from "react";
import { RouteComponentProps } from "react-router-dom";
import ImpiantoClimaForm, { ImpiantoClimaFormData, ToImpiantoData } from "./impiantoClimaForm";
import ImpiantiActions from "../ImpiantiClimaActions";
import { ImpiantoDto, ClienteDto } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";
import ImpiantiClimaStore from "../ImpiantiClimaStore";

interface ImpiantoClimaEditProps extends RouteComponentProps<{ id: string }> {
    impianto?: ImpiantoDto;
    cliente?: ClienteDto;
}

export default (props: ImpiantoClimaEditProps) => {
    let { history, match: { params: { id } } } = props;

    const impianto = ImpiantiClimaStore.use(parseInt(id));
    if (impianto == null)
        return <Loading />

    const save = async (i: ImpiantoClimaFormData) => {
        ImpiantiActions.update(ToImpiantoData(i), +id);
        history.replace(links.customerShow(impianto.idCliente));
    }

    return (
        <ImpiantoClimaForm
            impianto={impianto}
            onSubmit={save}
            onCancel={() => history.goBack()}
        />

    );
}

